
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/test/chat-popup",
      function () {
        return require("private-next-pages/test/chat-popup.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/test/chat-popup"])
      });
    }
  